import React, { useEffect } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import Button from "@mui/material/Button";
import lead from "../../assets/DigitalMarketing/non_ivf_bulk_upload.xlsx";
import ivflead from "../../assets/DigitalMarketing/ivf_customer.xlsx";
import { useGetAllBranchesQuery } from "../../Service/Masters";
import { useSelector } from "react-redux";

function DialogModal(props) {
  const {
    open,
    handleClose,
    title,
    formlist,
    handleSubmit,
    value,
    opt_list,
    isLoading,
    handleChange,
    setedit,
    download,
    btnName,
    submit,
    ivf,
  } = props;
  useEffect(() => {}, [props]);
  const { data: branchOptions } = useGetAllBranchesQuery({
    refetchOnMountOrArgChange: true,
  });
  const account = useSelector((state: any) => state.auth);
  const {roleName} = account
  return (
    <Modal
      className="mod"
      // size="lg"
      show={open}
      centered
      onHide={handleClose}
      animation={true}
    >
      <Modal.Body className="mx-1">
        <div className="d-flex justify-content-between">
          <h3 className="f-24 fw-600">{title}</h3>
          {download && (
            <a
              href={ivf ? ivflead : lead}
              download={ivf ? "Sample-ivf-leads.xlsx" : "Sample-leads.xlsx"}
            >
              <Button variant="contained" id="btn-save">
                Download Sample template
              </Button>
            </a>
          )}
        </div>
        <div className="mod-body mt-3 mb-3">
          <Row>
            {formlist?.map((item, index) => {
              return (
                <Col className="mb-2" md={12} key={index}>
                  {(item.name === "branchName" && roleName !== "branch") ? (
                    <div className=" mt-2">
                      <div>
                        <label className="form-label">Branch Name</label>
                      </div>
                      <div>
                        <select
                          className="form-control form-select"
                          name="branchId"
                          // value={medicine.branchId}
                          onChange={handleChange}
                          // disabled={view}
                        >
                          <option value="">Select Branch</option>
                          {branchOptions?.data?.map((branch) => (
                            <option key={branch.id} value={branch.id}>
                              {branch.branchName}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  ) : (
                    <item.tag
                      {...item}
                      opt_list={opt_list}
                      submit={submit}
                      {...value}
                      handleChange={handleChange}
                    />
                  )}
                </Col>
              );
            })}
          </Row>
        </div>
        <div>
          <Button
            variant="outlined"
            className="me-2"
            id="btn-outline"
            onClick={() => {
              handleClose();
              setedit(false);
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            id="btn-add"
            disabled={isLoading}
            onClick={handleSubmit}
          >
            {isLoading ? "Wait" : btnName ? btnName : "Upload"}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default DialogModal;
